import schema from '../form-configs/schema';
import data from '../form-configs/data';
import { customerInfoLayout, deliveryInfoLayout, invoiceInfoLayout } from '../form-configs/layout';

export const cancelInvoice = context => ({
  schema: {
    ...schema(context),
  },
  formModel: {
    ...data,
  },
  layout: {
    ...customerInfoLayout,
    ...invoiceInfoLayout,
    ...deliveryInfoLayout,
    'div.grid.grid-cols-1:2': {
      div: {
        slot: 'additional-info-title',
      },
      'div.grid.grid-cols-2.grid-rows-2.gap-x-30': {
        'div.col-span-1.md-col-span-1.row-span-2': { field: 'reason_change' },
        'div.col-span-1.md-col-span-1.row-span-1': { field: 'agreement_date' },
        'div.col-span-1.md-col-span-1.row-span-1:0': { field: 'evidence_for_change' },
        'div.col-span-1.md-col-span-1.row-span-1:1': { field: 'note_change' },
      },
      'div:0': {
        slot: 'additional-info-note',
      },
    },
  },
});

export default cancelInvoice;



// WEBPACK FOOTER //
// ./src/portal-components/invoice/actions-invoice/form-definition/cancel-invoice.js